import { useHistory } from 'react-router-dom';

import { Button } from '@motorway/mw-highway-code';

import { HOMEPAGE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsHomePage';
import { EVENT } from 'Utilities/analytics/optimizely/constants';
import { useOptimizelyTrack } from 'Utilities/analytics/optimizely/useOptimizelyTrack';

import { UseVehicleCardPropsReturn } from '../../../account/Components/VehicleCard/useVehicleCard';

type VehicleCardReturningUserCTAProps = UseVehicleCardPropsReturn['ctaProps'] & {
  vrm: string;
};

export const VehicleCardReturningUserCTA: React.FC<VehicleCardReturningUserCTAProps> = ({ vrm, ...ctaProps }) => {
  const history = useHistory();
  const { OPTIMIZELY_TRACK } = useOptimizelyTrack();

  const onClickCta = () => {
    const url = ctaProps.to || `/${vrm}/profile`;
    HOMEPAGE_SNOW_PLOW_EVENTS.HERO_RETURN_USER_CONTINUE_CLICKED({ buttonLabel: ctaProps.label, url });
    OPTIMIZELY_TRACK(EVENT.OFFER_SELECT);
    history.push(url);
  };

  return (
    <Button
      fullWidth
      icon="chevron"
      {...ctaProps}
      onClick={onClickCta}
    />
  );
};
